/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cerez_S7_ConjunctionInputs */

const tr_cerez_s7_conjunction = /** @type {(inputs: Cerez_S7_ConjunctionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ve`)
};

const en_cerez_s7_conjunction = /** @type {(inputs: Cerez_S7_ConjunctionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`and`)
};

const de_cerez_s7_conjunction = /** @type {(inputs: Cerez_S7_ConjunctionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`und`)
};

const ru_cerez_s7_conjunction = /** @type {(inputs: Cerez_S7_ConjunctionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`и`)
};

/**
* | output |
* | --- |
* | "and" |
*
* @param {Cerez_S7_ConjunctionInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const cerez_s7_conjunction = /** @type {((inputs?: Cerez_S7_ConjunctionInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cerez_S7_ConjunctionInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cerez_s7_conjunction(inputs)
	if (locale === "de") return de_cerez_s7_conjunction(inputs)
	if (locale === "ru") return ru_cerez_s7_conjunction(inputs)
	return tr_cerez_s7_conjunction(inputs)
});